import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const CultureApp = lazy(() => import('./CultureApp'));

const CultureAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: 'apps/culture',
      element: <CultureApp />,
    },
  ],
};

export default CultureAppConfig;
